<template>
    <span :class="pClass" v-if="column.customFunction">
        {{column.customFunction(data)}}
    </span>
    <span :class="pClass" v-else>
        {{data[column.field]}}
    </span>
</template>

<script>
    export default {
        name: "AncestrylineDataTableFieldDisplay",

        props:{
            pClass: {type: String, default: ''},
            column: {type: Object, default: null},
            data: {type: Object, default: null}
        }
    }
</script>